import React, { useState } from "react";
import { Sheet, SheetContent, SheetHeader, SheetTitle } from "@/components/ui/sheet";
import Attachments from "@/components/Attachments";
import { Paperclip } from "lucide-react";

/** Small reusable "attach" button that renders a Sheet with the Attachments panel. */
export default function AttachButton({ docType, docId, docNumber, size = "sm", variant = "ghost" }) {
  const [open, setOpen] = useState(false);
  if (!docId) return null;
  return (
    <>
      <button
        onClick={(e) => { e.stopPropagation(); setOpen(true); }}
        className="inline-flex items-center gap-1 text-[10px] font-mono uppercase text-muted-foreground hover:text-accent px-2 py-1 border rounded-sm"
        data-testid={`attach-btn-${docType}-${docNumber || docId}`}
      >
        <Paperclip className="w-3 h-3" /> Files
      </button>
      <Sheet open={open} onOpenChange={setOpen}>
        <SheetContent side="right" className="w-full sm:max-w-md rounded-none">
          <SheetHeader><SheetTitle className="font-heading">Attachments · {docNumber || docType}</SheetTitle></SheetHeader>
          <div className="mt-4">
            <Attachments docType={docType} docId={docId} />
          </div>
        </SheetContent>
      </Sheet>
    </>
  );
}
